<template>
  <div class="h-dialogContainer">
    <form id='updateDev'>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devType')}}:</div>
          <ejs-dropdownlist
             name="devType"
            :placeholder="devTypePlaceholder"
            :dataSource="typeData"
            v-model="devinfo.typeCode"
            :fields="typeFields"
            :readonly="readDeviceType"
            :noRecordsTemplate="noRecordsTemplate"
          ></ejs-dropdownlist>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devName')}}:</div>
          <input
            name="devName"
            class="e-input"
            :placeholder="devNamePlaceholder"
            type="text"
            v-model="devinfo.name"
          />
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <!--neId-->
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Observe.neId')}}:</div>
          <input name="id" :placeholder="neIdPlaceholder" v-model="devinfo.id" :disabled="true" type="text" class="e-input"/>
        </div>
      </div>
      <!--地区-->
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Observe.region')}}:</div>
          <input name="region" :placeholder="regionPlaceholder" v-model="devinfo.region" :disabled="true" type="text" class="e-input"/>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devSoftVersion')}}:</div>
          <ejs-dropdownlist
             name="devSoftVersion"
            :placeholder="devSoftVersionPlaceholder"
            :dataSource="visionData"
            v-model="devinfo.softwareVersion"
            :fields="visonFields"
            :readonly="readSoftware"
            :noRecordsTemplate="noRecordsTemplate"
          ></ejs-dropdownlist>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit">{{this.$t('Topo.altitude')}}:</div>
            <input name="devAltitude" :placeholder="devAltitudePlaceholder" v-model="devinfo.altitude" type="text" class="e-input"/>
          </div>
      </div>
    </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit">{{this.$t('Topo.longitude')}}:</div>
            <input name="devLongitude" :placeholder="devLongitudePlaceholder" v-model="devinfo.longitude" type="text" class="e-input"/>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit">{{this.$t('Topo.latitude')}}:</div>
            <input name="devLatitude" :placeholder="devLatitudePlaceholder" v-model="devinfo.latitude" type="text" class="e-input"/>
          </div>
        </div>
      </div>
    <IPAddrList ref='ipAddrList'></IPAddrList>
    </form>
    <div class="h-clear-rowMg"></div>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import IPAddrList from '../../../topoconfig/IPAddrList';
import { EventBus } from '../../../../plugins/eventBus';
var equipmentIPList = [];

export default {
  name: 'EditBSDevice',
  components: {
    IPAddrList,
  },
  data() {
    return {
      devNamePlaceholder: this.$t('Topo.devName'),
      devTypePlaceholder: this.$t('Topo.devType'),
      devSoftVersionPlaceholder: this.$t('Topo.devSoftVersion'),
      devLongitudePlaceholder: this.$t('Topo.longitudePlaceholder'), // 经度
      devLatitudePlaceholder: this.$t('Topo.latitudePlaceholder'),  // 纬度
      devAltitudePlaceholder: this.$t('Topo.altitudePlaceholder'),  // 高度
      neIdPlaceholder: this.$t('Observe.neId'), // 网元ID
      regionPlaceholder: this.$t('Observe.region'), // 地区
      devinfo: {
        id: '',
        name: '',
        typeCode: 0,
        clusterId:'',
        positionX: 225,
        positionY: 226,
        longitude: '',
        latitude: '',
        altitude: '',
        ipPortData: [],
        equipmentIPList: [],
        softwareVersion: '',
        displaySoftwareVersion:'',
        neId:'',
        region:'',
      },
      typeData: [],
      typeFields: { value: 'typeCode', text: 'nameKey' },
      visionData: [],
      visonFields: { value: 'softwareVersion', text: 'displaySoftwareVersion' },
      readDeviceType: true,
      readSoftware: true,
      noRecordsTemplate:  this.$t('Topo.noData'),
      type: 0, // 服务器or基站

      validationOption: {
        customPlacement(inputElement, errorElement) {
            errorElement.style.float = 'left';
            inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
            devType: {
                required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            devName: {
                required: [true, `${this.$t('Pm.alertRequired')}`],
                regex: [/^(^\S)/, `${this.$t('Topo.noEmptyStart')}`],
                maxLength: [30, `${this.$t('Topo.topoMaxLength')}30`],
            },
            devSoftVersion: {
                required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            devLongitude: {
              regex: ['^(\\-|\\+)?\\d+(\\.\\d+)?$', `${this.$t('System.inputNumber')}`],
              range: [[-180, 180], `${this.$t('Topo.longitudeIllegal')}`],
            },
            devLatitude: {
              regex: ['^(\\-|\\+)?\\d+(\\.\\d+)?$', `${this.$t('System.inputNumber')}`],
              range: [[-90, 90], `${this.$t('Topo.latitudeIllegal')}`],
            },
            devAltitude: {
              regex: ['^(\\-|\\+)?\\d*$', `${this.$t('System.inputInteger')}`],
              range: [[-9999, 9999], `${this.$t('Topo.altitudeIllegal')}`],
            },
            id: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
              regex: [/^(^\S)/, `${this.$t('Topo.noEmptyStart')}`],
              maxLength: [5, `${this.$t('Topo.topoMaxLength')}5`],
            },
        }
      },
    };
  },
  mounted() {
    this.bindValidate();
  },
  created(){
    this.queryDevType();
  },
  methods: {
    outputs(callback) {
      if (!this.validate()) {
        return;
      }
      //校验通信ip和端口
      const IpPortData = this.$refs.ipAddrList.getDatas();

      if(IpPortData === null){
        console.log('IpPortData === null')
        return;
      }
      const iPListTemp=[];
      for(var i in IpPortData){
        if(IpPortData[i].id ===''){  //id==''是新加的IP和端口
         iPListTemp.push({
            id: '',
            ip: IpPortData[i].ipaddr,
            port: parseInt(IpPortData[i].port),
            service:''
            })
        }
        const obj = equipmentIPList.find((item) => item.id === IpPortData[i].id);  //id已经存在的是修改的IP和端口
        if(obj !== undefined){
            iPListTemp.push({
            id: obj.id,
            ip: IpPortData[i].ipaddr,
            port: parseInt(IpPortData[i].port),
            service:obj.service,
            processCode:obj.processCode,
            equipmentId:obj.equipmentId,
            })
        }
      }
      this.devinfo.equipmentIPList = iPListTemp;
      this.threadIDMatch(this.devinfo.typeCode);

      if(this.devinfo.typeCode === 10003 && this.devinfo.clusterId !== 'null') //有归属集群的MCS设备service是mcs
      {
         this.devinfo.equipmentIPList[0].service = 'mcs';
      }
      const devInfo = {
        ...this.devinfo,
        typeCode: this.devinfo.typeCode.toString(),
      }
      // 修改网元
      this.axios.post('/lte/ems/topo/device/modifyDev', devInfo).then((response) => {
        if (response.data === undefined) {
          return;
        }
        if (response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
            this.closeWindow();
          if (callback) {
            callback('true');
          }
            return;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        }
        this.closeWindow();
        this.$emit('getDeviceListData');
      });
    },

    closeWindow() {
      this.$emit('close');
    },
    initData(devdata) {
      // 新建设备专用
      this.devinfo = {
          id: '',
          name: '',
          typeCode: '',
          subnetId: '',
          positionX: 255,
          positionY: 256,
          equipmentIPList: [],
          softwareVersion: '',
          displaySoftwareVersion:'',
          description: ''
        };
      if(devdata !== undefined){
        //查设备类型
        const This = this;
        const visionDataTemp = [];
        visionDataTemp.push({
                softwareVersion:devdata.softwareVersion,
                displaySoftwareVersion:devdata.displaySoftwareVersion
              })
        This.visionData = visionDataTemp;
        This.devinfo = devdata;
        equipmentIPList = devdata.equipmentIPList;
        //调整IP和端口的数量
        const args = {
        typeCode: this.devinfo.typeCode,
                }
        this.$refs.ipAddrList.initArgs(args);
        this.$refs.ipAddrList.initDatas(equipmentIPList);

      }
    },

      // 新建设备时去后台查设备类型
    queryDevType() {
        const This = this;
        const params={ };
        This.$axios.get(`/lte/ems/topo/device/devType/${this.type}`,params).then((response) => {
          if (response && response.status === 200 && response.data && response.data.errorCode === 'SUCCESS') {
            This.typeData = response.data.resultVal;
          } else {
            This.typeData = [];
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
      },

    threadIDMatch(value) {
      if(2==this.devinfo.equipmentIPList.length){
          if (value === 10001 ) {
          if(null==this.devinfo.equipmentIPList[0].service||''==this.devinfo.equipmentIPList[0].service){
          this.devinfo.equipmentIPList[0].service = 'epc';
          }
          if(null==this.devinfo.equipmentIPList[1].service||''==this.devinfo.equipmentIPList[1].service){
          this.devinfo.equipmentIPList[1].service = 'epc';
          }
        } else if (value === 10004 || value === 10005 || value === 10006 || value === 10008) {
          if(null==this.devinfo.equipmentIPList[0].service||''==this.devinfo.equipmentIPList[0].service){
          this.devinfo.equipmentIPList[0].service = 'enodeb';
          }
          if(null==this.devinfo.equipmentIPList[1].service||''==this.devinfo.equipmentIPList[1].service){
          this.devinfo.equipmentIPList[1].service = 'enodeb';
          }
        }  else if (value === 10009) {
          if(null==this.devinfo.equipmentIPList[0].service||''==this.devinfo.equipmentIPList[0].service){
          this.devinfo.equipmentIPList[0].service = 'gnb';
          }
          if(null==this.devinfo.equipmentIPList[1].service||''==this.devinfo.equipmentIPList[1].service){
          this.devinfo.equipmentIPList[1].service = 'gnb';
          }
        }
      }
      else{
        if (value === 10001 ) {
          if('tr069'!=this.devinfo.equipmentIPList[0].service){
          this.devinfo.equipmentIPList[0].service = 'epc';
          }
        } else if (value === 10004 || value === 10005 || value === 10006 || value === 10008) {
          if('tr069'!=this.devinfo.equipmentIPList[0].service){
          this.devinfo.equipmentIPList[0].service = 'enodeb';
          }
        }  else if (value === 10009) {
          if('tr069'!=this.devinfo.equipmentIPList[0].service){
          this.devinfo.equipmentIPList[0].service = 'gnb';
          }
        }
      }
      },
    bindValidate() {
      this.formObj = new FormValidator('#updateDev', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    },
  }
};
</script>
